import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitokonkandarshancab() {



  const cardData =
  {
    keyword: 'Mumbai to Konkan Darshan Cab Booking',
    heading: 'Shambhu Cabs: Mumbai to Konkan Darshan Cab Booking  ',
    headingDescription: 'Shambhu Cabs offers professional Mumbai to Konkan Darshan Cab Booking services, providing safe, comfortable, and hassle-free travel for families, friends, and corporate travelers exploring the scenic Konkan coast. Our fleet of hatchbacks, sedans, SUVs, and tempo travellers ensures a smooth and enjoyable journey from Mumbai to popular Konkan destinations including Alibaug, Murud, Ganpatipule, and Ratnagiri with well-maintained vehicles and spacious seating. With flexible one-way and round-trip options, experienced chauffeurs, and 24/7 booking support, Shambhu Cabs makes your Konkan Darshan trip convenient, stress-free, and memorable. From South Mumbai to Thane, Andheri to Vashi, Shambhu Cabs provides doorstep pickup and trusted Mumbai to Konkan Darshan cab services for travelers seeking comfort, safety, and scenic travel experiences.',

    top: 'Top Places to Visit in Konkan with Shambhu Cabs',

 "topPlaces": [
  {
    "title": "Ganpatipule Beach",
    "description": "Ganpatipule Beach is a pristine coastline known for its golden sands, clear waters, and the famous Swayambhu Ganapati Temple. The serene environment, coconut groves, and calm waves make it a perfect destination for relaxation and spiritual visits."
  },
  {
    "title": "Ratnagiri Fort",
    "description": "Also known as Ratnadurg Fort, this historic sea fort overlooks the Arabian Sea and offers panoramic views of Ratnagiri’s coastline. Built in the 16th century, the fort is a mix of military architecture and natural beauty, attracting history enthusiasts and photographers."
  },
  {
    "title": "Jaigad Fort",
    "description": "Jaigad Fort is a coastal fort perched atop cliffs, offering spectacular views of the Jaigad port and Arabian Sea. It is a relatively untouched fort with winding pathways, cannons, and lush surroundings, ideal for history lovers and trekkers."
  },
  {
    "title": "Tarkarli Beach",
    "description": "Tarkarli Beach is famous for its white sand, clear waters, and water sports activities like snorkeling, scuba diving, and boating. It is one of Maharashtra’s most scenic beaches, offering a perfect mix of adventure and relaxation."
  },
  {
    "title": "Kunkeshwar Temple",
    "description": "Kunkeshwar Temple, dedicated to Lord Shiva, is an ancient temple located near the Arabian Sea. Surrounded by natural beauty, it combines spiritual importance with a tranquil coastal setting, attracting pilgrims and tourists alike."
  },
  {
    "title": "Velneshwar Beach",
    "description": "Velneshwar Beach is a serene, less crowded beach known for its coconut groves, peaceful shoreline, and the ancient Shiva temple nearby. It is ideal for quiet retreats, meditation, and enjoying nature away from busy tourist spots."
  },
  {
    "title": "Murud Janjira Fort",
    "description": "Murud Janjira Fort is an impregnable sea fort located on an island near Murud village. Surrounded by deep waters and high walls, the fort is a marvel of Maratha naval architecture and history, drawing history buffs and tourists alike."
  },
  {
    "title": "Lalbaug Beach",
    "description": "Lalbaug Beach in Ratnagiri is a tranquil coastal spot known for its scenic beauty and sunsets. It is lined with coconut trees and offers a peaceful environment for picnics, beach walks, and photography."
  },
  {
    "title": "Shivaji Maharaj Museum, Ratnagiri",
    "description": "Located in Ratnagiri, this museum showcases the life and legacy of Chhatrapati Shivaji Maharaj. With historical artifacts, paintings, and exhibits, it provides deep insights into Maratha history and Konkan culture."
  },
  {
    "title": "Anjarle Beach & Kadyavarcha Ganpati Temple",
    "description": "Anjarle Beach is a scenic coastal spot, famous for its quiet atmosphere and the Kadyavarcha Ganpati Temple situated nearby. The temple draws devotees while the beach offers a peaceful retreat amidst natural beauty."
  }
],


"services": [
  {
    "name": "Konkan Darshan Taxi Mumbai",
    "description": "Konkan Darshan Taxi Mumbai offers a complete travel solution for passengers looking to explore the scenic Konkan region. The service includes well-maintained vehicles, professional drivers familiar with coastal routes, and flexible scheduling. Perfect for families, couples, and solo travelers, it ensures a safe, comfortable, and memorable journey through the lush landscapes, beaches, and forts of Konkan."
  },
  {
    "name": "Mumbai Konkan Tour Cab",
    "description": "Mumbai Konkan Tour Cab specializes in organizing hassle-free tours across the Konkan coast. Passengers can choose from sedans, SUVs, and luxury cars, all driven by experienced chauffeurs. The service includes route planning, sightseeing recommendations, and flexible pickup and drop options, making it ideal for travelers seeking a comprehensive Konkan tour experience from Mumbai."
  },
  {
    "name": "Konkan Road Trip Cab Mumbai",
    "description": "Konkan Road Trip Cab Mumbai is designed for travelers who wish to enjoy long drives and scenic coastal routes. Vehicles are comfortable and spacious, drivers are skilled in highway and coastal driving, and schedules are flexible. This service ensures a smooth, safe, and enjoyable journey for weekend getaways, family trips, or group excursions along the Konkan coast."
  },
  {
    "name": "Mumbai to Konkan Car Rental",
    "description": "Mumbai to Konkan Car Rental provides affordable and flexible car hire services for travelers visiting Konkan. Customers can choose from a range of sedans, SUVs, and premium vehicles, all equipped with modern amenities. Professional drivers ensure a safe and convenient journey, whether traveling for leisure, family trips, or adventure tours along the Konkan coastline."
  },
  {
    "name": "Konkan Coastal Cab Mumbai",
    "description": "Konkan Coastal Cab Mumbai offers specialized transportation for passengers looking to explore the beaches, forts, and hill stations of Konkan. Comfortable vehicles, professional drivers, and scenic route expertise ensure a smooth, safe, and enjoyable travel experience. Ideal for weekend trips, family outings, and group excursions along the coastal region."
  },
  {
    "name": "Best Konkan Darshan Cab",
    "description": "Best Konkan Darshan Cab is known for its superior service, punctuality, and well-maintained vehicles. This service caters to tourists, families, and corporate groups seeking a reliable and comfortable travel experience. Passengers can enjoy scenic drives, timely pickups, and hassle-free journeys while exploring the beautiful Konkan region from Mumbai."
  },
  {
    "name": "Affordable Konkan Trip Cab",
    "description": "Affordable Konkan Trip Cab provides budget-friendly options for travelers heading to the Konkan region. Vehicles are clean, well-maintained, and driven by professional chauffeurs. Passengers can enjoy a safe, comfortable, and economical journey, making it ideal for students, small families, or groups looking to explore the Konkan coast without spending too much."
  },
  {
    "name": "Konkan Beaches Cab Mumbai",
    "description": "Konkan Beaches Cab Mumbai focuses on providing convenient transportation to the popular beaches of Konkan, including Ganpatipule, Tarkarli, and Velneshwar. Comfortable vehicles, experienced drivers, and flexible itineraries ensure a memorable beach trip. This service is perfect for family outings, weekend getaways, and long drives along the coastal route."
  },
  {
    "name": "Mumbai to Ratnagiri Cab",
    "description": "Mumbai to Ratnagiri Cab provides seamless transportation for travelers heading to Ratnagiri. The service includes well-maintained sedans and SUVs, experienced drivers familiar with the Konkan highways, and on-time pickups. Ideal for leisure trips, family vacations, or sightseeing tours, it ensures a comfortable and safe journey from Mumbai to Ratnagiri."
  },
  {
    "name": "Mumbai to Sindhudurg Cab",
    "description": "Mumbai to Sindhudurg Cab offers reliable and safe travel options for visitors heading to the Sindhudurg district. The service features spacious and comfortable vehicles, professional drivers, and flexible scheduling. Passengers can enjoy scenic coastal drives, timely arrivals, and a hassle-free journey to explore the forts, beaches, and local culture of Sindhudurg."
  },
  {
    "name": "Mumbai to Guhagar Cab",
    "description": "Mumbai to Guhagar Cab provides dedicated transportation for travelers visiting the tranquil town of Guhagar in Konkan. With well-maintained vehicles, skilled drivers, and personalized service, passengers can enjoy a safe and smooth journey. This option is perfect for beach lovers, small groups, and families seeking a peaceful getaway from Mumbai."
  },
  {
    "name": "Mumbai to Dapoli Taxi",
    "description": "Mumbai to Dapoli Taxi ensures comfortable and reliable travel to the scenic coastal town of Dapoli. The service includes a range of vehicles, professional drivers, and flexible pickup/drop options. Ideal for weekend trips, family outings, and long drives along the Konkan coast, it guarantees a safe, enjoyable, and memorable journey from Mumbai."
  },
  {
    "name": "Mumbai Konkan Family Tour Cab",
    "description": "Mumbai Konkan Family Tour Cab specializes in group and family travel across the Konkan region. Spacious vehicles, experienced drivers, and planned itineraries ensure a comfortable, safe, and fun journey. Passengers can enjoy sightseeing, beach visits, and cultural experiences along the Konkan coast with minimal stress and maximum convenience."
  },
  {
    "name": "SUV Cab Konkan Darshan",
    "description": "SUV Cab Konkan Darshan provides travelers with spacious and comfortable SUVs for exploring the Konkan region. Professional drivers, modern vehicles, and safe highway driving ensure a pleasant journey for families, groups, or corporate clients. Ideal for long-distance travel, sightseeing tours, and scenic coastal trips from Mumbai."
  },
  {
    "name": "Sedan Cab Konkan Trip",
    "description": "Sedan Cab Konkan Trip offers economical and comfortable travel in sedans for solo travelers, couples, and small families visiting Konkan. The service includes professional drivers, well-maintained vehicles, and flexible schedules. Passengers can enjoy scenic routes, safe travel, and a relaxed journey from Mumbai to various Konkan destinations."
  },
  {
    "name": "Long Drive Cab Mumbai Konkan",
    "description": "Long Drive Cab Mumbai Konkan specializes in extended trips along the Konkan coast. Comfortable vehicles, experienced drivers, and scenic route knowledge make long drives safe and enjoyable. Perfect for weekend getaways, adventure trips, and family outings, this service ensures a stress-free journey through the picturesque coastal highways from Mumbai."
  },
  {
    "name": "24×7 Mumbai Konkan Cab",
    "description": "24×7 Mumbai Konkan Cab provides round-the-clock taxi services for travelers heading to the Konkan region. Regardless of departure time, the service offers well-maintained vehicles, professional drivers, and reliable pickups. Ideal for last-minute trips, early departures, or late returns, it ensures a convenient and safe journey along the Mumbai–Konkan route."
  }
],

"tableData": [
  ["Konkan Darshan Taxi Mumbai", "Mumbai Konkan Tour Cab"],
  ["Konkan Road Trip Cab Mumbai", "Mumbai to Konkan Car Rental"],
  ["Konkan Coastal Cab Mumbai", "Best Konkan Darshan Cab"],
  ["Affordable Konkan Trip Cab", "Konkan Beaches Cab Mumbai"],
  ["Mumbai to Ratnagiri Cab", "Mumbai to Sindhudurg Cab"],
  ["Mumbai to Guhagar Cab", "Mumbai to Dapoli Taxi"],
  ["Mumbai Konkan Family Tour Cab", "SUV Cab Konkan Darshan"],
  ["Sedan Cab Konkan Trip", "Long Drive Cab Mumbai Konkan"],
  ["24×7 Mumbai Konkan Cab", "—"]
],


"whychoose": [
  {
    "WhyChooseheading": "Mumbai to Konkan Darshan Cab Booking with Shambhu Cabs",
    "WhyChoosedescription": "Shambhu Cabs offers reliable Mumbai to Konkan Darshan cab services, perfect for scenic coastal trips, family vacations, and comfortable long-distance travel along the Konkan coast."
  },
  {
    "WhyChooseheading": "Comfortable and Well-Maintained Vehicles",
    "WhyChoosedescription": "Travel in spacious, air-conditioned, and regularly serviced cabs to enjoy a smooth and relaxing journey during your Konkan Darshan trip."
  },
  {
    "WhyChooseheading": "Experienced Drivers for Coastal Routes",
    "WhyChoosedescription": "Our professional drivers are familiar with the Mumbai to Konkan routes, ensuring safe, timely, and comfortable travel throughout your journey."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Enjoy clear and upfront pricing—fuel, tolls, and driver allowances included—making your Mumbai to Konkan Darshan cab booking hassle-free."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our dedicated support team is available round the clock to assist with bookings, travel queries, and route guidance for your trip."
  },
  {
    "WhyChooseheading": "Flexible Rental Plans for Coastal Travel",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized rental plans tailored to your Mumbai to Konkan Darshan travel needs."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All cabs are thoroughly cleaned and sanitized before every trip to ensure a hygienic and safe travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and smooth service, making your Mumbai to Konkan Darshan journey stress-free and comfortable."
  }
]




















  }

const faqData = [
  {
    question: 'Does Shambhu Cabs offer Mumbai to Konkan Darshan cab services?',
    answer: 'Yes, Shambhu Cabs provides reliable and comfortable Mumbai to Konkan Darshan cab services, perfect for sightseeing and leisure trips along the Konkan coast.',
  },
  {
    question: 'How can I book a Mumbai to Konkan Darshan cab with Shambhu Cabs?',
    answer: 'You can easily book through our website, mobile app, or by contacting our 24x7 customer support team for assistance.',
  },
  {
    question: 'What types of vehicles are available for Mumbai to Konkan Darshan cab bookings?',
    answer: 'Shambhu Cabs offers well-maintained sedans, SUVs, and luxury cars suitable for day trips or multi-day Konkan Darshan travel.',
  },
  {
    question: 'Are drivers experienced for the Mumbai to Konkan Darshan route?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with the scenic Konkan route to ensure a safe and enjoyable journey.',
  },
  {
    question: 'Can I choose custom pickup and drop-off locations for my Mumbai to Konkan Darshan trip?',
    answer: 'Absolutely. You can select your preferred pickup point in Mumbai and drop-off locations anywhere along the Konkan Darshan itinerary.',
  },
  {
    question: 'Is the Mumbai to Konkan Darshan cab service available 24x7 with Shambhu Cabs?',
    answer: 'Yes, Shambhu Cabs offers round-the-clock cab booking services for Mumbai to Konkan Darshan trips to suit your schedule.',
  },
  {
    question: 'Are safety and hygiene measures followed for Mumbai to Konkan Darshan cab bookings?',
    answer: 'All vehicles are sanitized regularly, and drivers follow strict safety and hygiene protocols to ensure passenger safety during the trip.',
  },
  {
    question: 'What payment options are available for Mumbai to Konkan Darshan cab bookings?',
    answer: 'We accept UPI, digital wallets, credit/debit cards, bank transfers, and corporate account payments.',
  },
  {
    question: 'Is customer support available during the Mumbai to Konkan Darshan journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Mumbai to Konkan Darshan trip for any assistance.',
  },
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Rajesh Patil',
    feedback: 'Our Mumbai to Konkan Darshan trip with Shambhu Cabs was smooth and enjoyable. Excellent service and scenic route experience!',
    rating: 5,
  },
  {
    id: 2,
    name: 'Ms. Priya Deshmukh',
    feedback: 'Highly reliable Mumbai to Konkan Darshan cab service. Comfortable car, professional driver, and hassle-free booking.',
    rating: 5,
  },
];














































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "mumbai-outstation-cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "mumbai-to-mahabaleshwar-cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "mumbai-to-goa-cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "mumbai-to-shirdi-cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "mumbai-nashik-cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "mumbai-to-kolhapur-cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "mumbai-to-pune-cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "mumbai-to-aurangabad-cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "mumbai-to-bhimashankar-cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "mumbai-to-ashtavinayak-cab-service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "mumbai-to-5-jyotirlinga-cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "mumbai-to-lonavala-cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "mumbai-to-konkan-darshan-cab-booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "mumbai-to-alibaug-cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "mumbai-to-ahmednagar-cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran Cab", link: "mumbai-to-matheran-cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon / Dhule Cab", link: "mumbai-to-jalgaon-dhule-cab" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "mumbai-to-lavasa-cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "mumbai-to-panchgani-cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "mumbai-to-khandala-taxi-fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "mumbai-to-surat-cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "mumbai-to-ahmedabad-cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "mumbai-to-narmada-parikrama-cab-booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Vadodara Cab", link: "mumbai-to-vadodara-cab" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman Taxi", link: "mumbai-to-daman-taxi" },
  ];









const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Konkan Darshan Cab Booking",
  "image": "https://www.shambhucab.com/assets/images/mumbai-to-konkan-cab.jpg",
  "description": "Shambhu Cabs provides safe and reliable Mumbai to Konkan Darshan cab services for coastal trips, family outings, and long drives. Book sedans, SUVs, or premium cars for trips to Ratnagiri, Sindhudurg, Guhagar, Dapoli, and Konkan beaches. Enjoy affordable fares, professional drivers, and 24×7 service.",
  "brand": {
    "@type": "Brand",
    "name": "Shambhu Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.9",
    "ratingCount": "5300",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "6000",
    "availability": "https://schema.org/InStock",
    "url": "https://www.shambhucab.com/mumbai-to-konkan-darshan-cab-booking"
  }
};


  return (
    <div>
<Helmet>
  <title>Mumbai to Konkan Darshan Cab | Coastal & Family Tour Taxi | Shambhu Cabs</title>

  <meta
    name="description"
    content="Book Mumbai to Konkan Darshan cab with Shambhu Cabs. Affordable and reliable taxi service for trips to Konkan beaches, Ratnagiri, Sindhudurg, Guhagar, Dapoli, and family tours. Available 24×7 with sedan, SUV, and premium cars."
  />

  <meta
    name="keywords"
    content="Konkan Darshan Taxi Mumbai, Mumbai Konkan Tour Cab, Konkan Road Trip Cab Mumbai, Mumbai to Konkan Car Rental, Konkan Coastal Cab Mumbai, Best Konkan Darshan Cab, Affordable Konkan Trip Cab, Konkan Beaches Cab Mumbai, Mumbai to Ratnagiri Cab, Mumbai to Sindhudurg Cab, Mumbai to Guhagar Cab, Mumbai to Dapoli Taxi, Mumbai Konkan Family Tour Cab, SUV Cab Konkan Darshan, Sedan Cab Konkan Trip, Long Drive Cab Mumbai Konkan, 24×7 Mumbai Konkan Cab"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


      <section className="gauto-breadcromb-area section_70">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="breadcromb-box">
                <h3> {cardData.keyword}</h3>
              </div>
            </div>
          </div>
        </div>
      </section>







      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/11.jpg' alt='img' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>

            

              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shambhu Cabs</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shambhu Cabs </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919819399797" className="pc-call">+91 9819399797</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919819399797"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+919819399797" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shambhucab.com" className="pc-email">
                      booking@shambhucab.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shambhu Cabs</strong><br />
                      Saket Tata Power CHS, Swami Samarth Marg,
                      Juhu Nagar, Sector-16, Vashi, Navi Mumbai,
                      Maharashtra India - 400703
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitokonkandarshancab;